
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import TitleSidebar from '@/components/details/TitleSidebar.vue';

import { SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';

import { TitleDetailsNode } from '@/interfaces/title-details-graphql';
import { TitleContentType } from '@/interfaces/snowplow/title-context';

@Component({
	name: 'InfoBox',
	components: { TitleSidebar },
})
export default class InfoBox extends Vue {
	// TODO [Graphql]: Substitute for required fields only, each field - new prop
	@Prop({ required: true }) title: TitleDetailsNode;
	@Prop({ default: () => [] }) additionalContexts: SnowplowContext[];
	@Prop({ default: false }) isBackdropTrailerPlaying: boolean;
	@Prop({ default: false }) hasBackdropContent: boolean;
	@Prop() titleContentType: TitleContentType | undefined;
}
